



























































































import { defineComponent, computed, PropType, ref } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import useSwitchDevice from "@/store/modules/useSwitchDevice";
import { alarm, sensor } from "@/store";
import useTimerSchedule from "@/store/useTimerSchedule";
import UserSettingsViewModel from "../../../models/UserSettingsViewModel";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        PairToggle: () =>
            import(/*webpackChunkName: "components"*/ "../PairToggle.vue"),
        TimerDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/TimerDialog.vue"),
        EditNicknameDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/EditNicknameDialog.vue"),
    },
    props: {
        value: Object as PropType<AttachedDeviceModel>,
    },
    setup(props, { emit }) {
        const { turnOn, turnOff } = useSwitchDevice();
        const { get } = useTimerSchedule();
        const showEditNickname = ref(false);

        const paired = computed<boolean>(() => !!props.value?.attachedDeviceId);

        const isConnecting = computed<boolean>(() => props.value?.isConnecting === true);

        const responsive = computed<boolean>(() =>
            props.value?.attachedDeviceId ? props.value.age < 4 : false
        );

        const switchStatus = computed<boolean>(() => {
            return ((props.value as any)?.status === true);
        });

        const showTimer = ref(false);

        const imgSrc = computed(() => require(`@/assets/img/digital-io.png`));

        const onEnroll = () => {
            if (props.value) emit('enroll', { typeId: props.value.attachedDeviceTypeId, img: imgSrc.value });
        };

        const onUnpair = () => {
            if (props.value) emit('unpair', { deviceId: props.value.attachedDeviceId })
        };

        const sensorSyncronising = computed(() => !!((props.value as any)?.isBusy || (props.value as any)?.isConnecting));

        const switchChange = (next: boolean) => {
            if (!props.value) return;
            // Send command
            if (next) turnOn(props.value.attachedDeviceId);
            else turnOff(props.value.attachedDeviceId);
            // Optimistic UI
            (props.value as any).status = next;
        };

        get(props.value?.attachedDeviceTypeId);

        const handleOnSaveNickname = (model: UserSettingsViewModel) => {
            emit("OnNewNickname", model);
        };

        return {
            onEnroll,
            onUnpair,
            paired,
            showTimer,
            imgSrc,
            responsive,
            switchStatus,
            sensorSyncronising,
            switchChange,
            handleOnSaveNickname,
            isConnecting,
            showEditNickname,
        };
    },
});
